module.exports = __webpack_public_path__ + "static/media/create-offer.b683dbc2.svg";